import React from 'react';
import { MicrophoneDevice } from '../types/microphone';

export interface MicrophoneSelectorProps {
  /** Available microphone devices */
  devices: MicrophoneDevice[];
  /** Currently selected device ID */
  selectedDeviceId: string | null;
  /** Called when device selection changes */
  onDeviceChange: (deviceId: string) => void;
  /** Whether the selector is disabled */
  disabled?: boolean;
  /** Whether device enumeration is in progress */
  isLoading?: boolean;
}

export const MicrophoneSelector: React.FC<MicrophoneSelectorProps> = ({
  devices,
  selectedDeviceId,
  onDeviceChange,
  disabled = false,
  isLoading = false,
}) => {
  const handleDeviceChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onDeviceChange(event.target.value);
  };

  if (isLoading) {
    return (
      <div className="microphone-selector">
        <label htmlFor="microphone-select">Microphone:</label>
        <select id="microphone-select" disabled>
          <option>Detecting microphones...</option>
        </select>
      </div>
    );
  }

  if (devices.length === 0) {
    return (
      <div className="microphone-selector">
        <label htmlFor="microphone-select">Microphone:</label>
        <select id="microphone-select" disabled>
          <option>No microphones detected</option>
        </select>
      </div>
    );
  }

  return (
    <div className="microphone-selector">
      <label htmlFor="microphone-select">Microphone:</label>
      <select
        id="microphone-select"
        value={selectedDeviceId || ''}
        onChange={handleDeviceChange}
        disabled={disabled}
      >
        {devices.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label || `Microphone ${device.deviceId.slice(0, 8)}...`}
            {device.isDefault ? ' (Default)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};